export class Notificacion {
    constructor(
        public id: number,
        public titulo: string,
        public descripcion: string,
        public data: any
    ) { }
}